export interface Job {
  id: string
  title: string
  company: string
  location: string
  type: 'Heltid' | 'Deltid' | 'Vikariat' | 'Prosjekt'
  salary: string
  description: string
  requirements: string[]
  benefits: string[]
  tags: string[]
  postedDays: number
}

export const mockJobs: Job[] = [
  {
    id: '1',
    title: 'Senior Frontend Utvikler',
    company: 'TechNorge AS',
    location: 'Oslo',
    type: 'Heltid',
    salary: '700 000 - 850 000 kr',
    description:
      'Vi søker en erfaren frontend-utvikler som brenner for React og TypeScript. Du vil jobbe med spennende prosjekter for både norske og internasjonale kunder.',
    requirements: [
      '5+ år erfaring med React',
      'Solid TypeScript-kunnskap',
      'Erfaring med state management',
      'God forståelse for UX'
    ],
    benefits: [
      'Konkurransedyktig lønn',
      'Fleksibel arbeidstid',
      'Hjemmekontor 3 dager/uke',
      'Kurs og konferanser',
      '6 ukers ferie'
    ],
    tags: ['React', 'TypeScript', 'Tailwind', 'Remote'],
    postedDays: 2
  },
  {
    id: '2',
    title: 'Fullstack Utvikler',
    company: 'StartUp Bergen',
    location: 'Bergen',
    type: 'Heltid',
    salary: '600 000 - 750 000 kr',
    description:
      'Bli med i et ungt, ambisiøst team som bygger neste generasjons SaaS-plattform. Vi tilbyr eierandeler og store vekstmuligheter.',
    requirements: [
      'Erfaring med Node.js og React',
      'Database-design (PostgreSQL)',
      'REST API utvikling',
      'Cloud deployment (AWS/Azure)'
    ],
    benefits: [
      'Eierandeler i selskapet',
      'Moderne kontor ved sjøen',
      '100% fleksibel arbeidstid',
      'Gratis lunsj',
      'Treningsavtale'
    ],
    tags: ['Node.js', 'React', 'PostgreSQL', 'Startup'],
    postedDays: 5
  },
  {
    id: '3',
    title: 'DevOps Engineer',
    company: 'CloudSolutions Norge',
    location: 'Trondheim',
    type: 'Heltid',
    salary: '750 000 - 900 000 kr',
    description:
      'Vi trenger en DevOps-ekspert som kan automatisere og optimalisere vår CI/CD-pipeline. Du vil jobbe tett med utviklingsteamene.',
    requirements: [
      'Kubernetes og Docker',
      'Terraform eller Pulumi',
      'GitHub Actions / GitLab CI',
      'Monitoring og logging',
      'Security best practices'
    ],
    benefits: [
      'Toppmoderne utstyr',
      'Remote-first kultur',
      'Sertifiseringer dekkes',
      'Bonusordning',
      'Sosialt miljø'
    ],
    tags: ['Kubernetes', 'Docker', 'Terraform', 'AWS'],
    postedDays: 1
  },
  {
    id: '4',
    title: 'UX/UI Designer',
    company: 'Design Studio Oslo',
    location: 'Oslo',
    type: 'Heltid',
    salary: '550 000 - 700 000 kr',
    description:
      'Vi søker en kreativ designer som elsker å lage intuitive brukeropplevelser. Erfaring med design systems og Figma er viktig.',
    requirements: [
      'Figma og Adobe Creative Suite',
      'Prototyping og user testing',
      'Design systems',
      'Mobil-first design',
      'Brukerforskning'
    ],
    benefits: [
      'Kreativt miljø',
      'Fleksible timer',
      'Moderne Apple-utstyr',
      'Konferanser i inn- og utland',
      'Fribar på fredager'
    ],
    tags: ['Figma', 'UI/UX', 'Design Systems', 'Mobile'],
    postedDays: 3
  },
  {
    id: '5',
    title: 'Backend Developer - Python',
    company: 'DataTech AS',
    location: 'Stavanger',
    type: 'Heltid',
    salary: '650 000 - 800 000 kr',
    description:
      'Bli med i vårt AI-team og bygg skalerbare backend-løsninger med Python. Vi jobber med maskinlæring og big data.',
    requirements: [
      'Python og FastAPI/Django',
      'SQL og NoSQL databaser',
      'Microservices arkitektur',
      'Machine learning basics',
      'Testing og dokumentasjon'
    ],
    benefits: [
      'Spennende AI-prosjekter',
      'Teknisk vekst',
      'Competitive salary',
      'Pensjonsordning',
      'Helseforsikring'
    ],
    tags: ['Python', 'FastAPI', 'AI/ML', 'MongoDB'],
    postedDays: 7
  },
  {
    id: '6',
    title: 'React Native Utvikler',
    company: 'Mobile First',
    location: 'Oslo',
    type: 'Heltid',
    salary: '680 000 - 820 000 kr',
    description:
      'Utvikle cross-platform mobilapper for spennende kunder. Vi leter etter noen som mestrer React Native og har øye for detaljer.',
    requirements: [
      'React Native erfaring',
      'Native modules (iOS/Android)',
      'App store deployment',
      'Performance optimization',
      'TypeScript'
    ],
    benefits: [
      'iPhone og Android-enheter',
      'Remote-first',
      'Kurs i Swift/Kotlin',
      '5 ukers ferie',
      'Sosiale arrangementer'
    ],
    tags: ['React Native', 'Mobile', 'TypeScript', 'iOS/Android'],
    postedDays: 4
  },
  {
    id: '7',
    title: 'Lead Developer',
    company: 'Enterprise Solutions',
    location: 'Oslo',
    type: 'Heltid',
    salary: '850 000 - 1 000 000 kr',
    description:
      'Lei et team på 6 utviklere og ta ansvar for teknisk arkitektur. Vi søker erfaren tech lead med sterk kommunikasjon.',
    requirements: [
      '8+ år utviklingserfaring',
      'Team leadership',
      'System arkitektur',
      'Agile metodikk',
      'Stakeholder management'
    ],
    benefits: [
      'Lederutvikling',
      'Høy autonomi',
      'Aksjer',
      'Bil-ordning',
      'Seniorkultur'
    ],
    tags: ['Leadership', 'Architecture', 'Agile', 'Enterprise'],
    postedDays: 2
  },
  {
    id: '8',
    title: 'Junior Utvikler - Trainee',
    company: 'Code Academy',
    location: 'Bergen',
    type: 'Heltid',
    salary: '450 000 - 550 000 kr',
    description:
      'Perfekt for nyutdannede! Vi tilbyr strukturert opplæring og mentoring. Du vil lære moderne webutvikling fra bunnen av.',
    requirements: [
      'Grunnleggende programmering',
      'Nysgjerrighet og lærevillighet',
      'Teamplayer',
      'Bachelor i IT/relatert'
    ],
    benefits: [
      'Mentor-program',
      'Strukturert opplæring',
      'Unge kollegaer',
      'Karrieremuligheter',
      'Kurs og sertifiseringer'
    ],
    tags: ['Junior', 'Trainee', 'JavaScript', 'Learning'],
    postedDays: 1
  }
]
